import { Component, OnInit, ViewChild, Input, HostBinding } from '@angular/core';
import { ZoningCodeService } from '../../core/services/zoning-code.service';
import { filter } from 'rxjs/operators';
import { LoaderService } from '../../../shared/services';
import { MatPaginator } from '@angular/material/paginator';
import {
    TableType,
    getCalibrationSetTypeId,
    CalibrationSetCollectionName,
    CalibrationSetType
} from '../../../shared/enums';
import { IZoningCodeModel } from 'src/app/interfaces/zoning-code-model.interface';
import * as _ from 'lodash';
import { NA_VALUE } from 'src/app/constants';
import { UsesTableModel } from 'src/app/models/tables/uses-table.model';

@Component({
    standalone: false,
    selector: 'zones-uses',
    templateUrl: './zones-uses.component.html',
    styleUrls: ['./zones-uses.component.scss']

})
export class ZonesUsesComponent implements OnInit {
    @HostBinding('class')
    readonly hostClass = 'zones-uses';

    @ViewChild(MatPaginator)
    paginator: MatPaginator;

    @Input()
    currentTab: string;

    @Input()
    hideUseComponentsSelection: boolean = false;

    @Input()
    hideAttributeButtons: boolean = false;

    @Input()
    readOnly: boolean = false;

    @Input()
    uploadZoningCode: boolean = true;

    @Input()
    set zoningCode(value) {
        this.initZoningCode(value);
    }

    get zoningCode() {
        return this._zoningCode;
    }

    calibrationSetType: CalibrationSetType;

    constructor(private readonly zcService: ZoningCodeService, private loaderService: LoaderService) {}

    _zoningCode: IZoningCodeModel = null;
    columnsToShow = [];
    pageSize = 10;
    allowancesList = [];

    usesVisibleFields: any = {
        showUseAllowance: true,
        showUseLimit: false,
        showParkingRequired: false
    };

    get table() {
        return _.get(this._zoningCode, `tables[${this.currentTab}].usesTable`) as UsesTableModel;
    }

    get usesTypes() {
        return _.get(this.table, 'usesTypes');
    }

    ngOnInit() {
        this.calibrationSetType = getCalibrationSetTypeId(this.currentTab);
        if (this.uploadZoningCode) {
            this.loaderService.show();
            this.zcService.zoningCodes.pipe(filter(zc => zc !== null && zc.length > 0)).subscribe(zc => {
                this.initZoningCode(zc[0]);
            });
        }
    }

    initZoningCode(zoningCode: IZoningCodeModel) {
        this._zoningCode = zoningCode;
        if (!this._zoningCode) {
            return;
        }
        this._zoningCode.initCalibrationSetTable(TableType.CALIBRATION_USES, this.currentTab);
        this.allowancesList = this._zoningCode.AllowedUses;
        if (this.currentTab === CalibrationSetCollectionName.CALIBRATION_ZONE_COMBINATION) {
            this.allowancesList = this.allowancesList.filter(e => e.UseConditionId !== NA_VALUE);
        }

        this.loaderService.hide();
        this.setPageData({ pageIndex: 0 });
    }

    setPageData(event?: any) {
        const startIndex = event.pageIndex * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        // TODO :: improve typings
        this.columnsToShow = this.table ? this.table.value.slice(startIndex, endIndex) : [];
    }
}
